import React from 'react';
import { Tag } from 'primereact/tag';
import {
    SP_SKIP,
    extractResponseData,
    SmartSection,
    NoRecordsCard,
    RawResponseButton,
} from './_SmartFieldRenderer';

const GROUPS = {
    overview: { title: 'Company Overview', icon: 'pi-building', keys: ['cin', 'company_name', 'company_status', 'company_type', 'company_category', 'class_of_company'] },
    incorporation: { title: 'Incorporation', icon: 'pi-calendar', keys: ['date_of_incorporation', 'roc', 'registration_number', 'listing_status'] },
    financials: { title: 'Financials', icon: 'pi-dollar', keys: ['authorized_capital', 'paid_up_capital', 'last_agm_date', 'last_bs_date'] },
    contact: { title: 'Contact', icon: 'pi-envelope', keys: ['email', 'address', 'city', 'state', 'pin_code', 'country'] },
    directors: { title: 'Directors', icon: 'pi-users', keys: ['directors'] },
};
const HIGHLIGHT = ['cin'];

const CompanyDetailsOutputComponent = ({ reportData, hideCredits, isSharedView }) => {
    const shouldHideCredits = hideCredits || isSharedView;
    const { responseData, remainingBalance, errorMsg, hasRealData } = extractResponseData(reportData);

    if (!reportData) return <NoRecordsCard subtitle="No data available" />;
    if (!responseData || !hasRealData) {
        return <NoRecordsCard errorMsg={errorMsg} subtitle="No records found for the provided details. Please verify and try again." />;
    }

    const d = responseData;
    const grouped = {};
    for (const [groupName, group] of Object.entries(GROUPS)) {
        const picked = {};
        group.keys.forEach((k) => { if (k in d && d[k] !== null && d[k] !== undefined && d[k] !== '') picked[k] = d[k]; });
        if (Object.keys(picked).length > 0) grouped[groupName] = picked;
    }
    const knownKeys = new Set(Object.values(GROUPS).flatMap((g) => g.keys));
    const leftover = {};
    for (const [k, v] of Object.entries(d)) {
        if (SP_SKIP.has(k) || knownKeys.has(k)) continue;
        if (v === null || v === undefined || v === '') continue;
        leftover[k] = v;
    }

    return (
        <div>
            {/* Sub-header — clean Lending-Network style */}
            <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2 mb-3">
                <h2 className="text-lg font-semibold text-900 m-0">
                    <i className="pi pi-building mr-2 text-primary" aria-hidden="true" />
                    Company Details Report
                </h2>
                {!shouldHideCredits && remainingBalance !== undefined && (
                    <Tag
                        severity="success"
                        icon="pi pi-wallet"
                        value={`Remaining: ${remainingBalance}`}
                        className="text-sm"
                    />
                )}
            </div>

            {/* Sections rendered via SmartFieldRenderer (already migrated) */}
            <div className="surface-card border-1 surface-border border-round p-3">
                {Object.entries(GROUPS).map(([groupName, meta]) =>
                    grouped[groupName] ? (
                        <SmartSection
                            key={groupName}
                            title={meta.title}
                            icon={meta.icon}
                            data={grouped[groupName]}
                            highlightKeys={HIGHLIGHT}
                        />
                    ) : null
                )}
                {Object.keys(leftover).length > 0 && (
                    <SmartSection title="Other Details" icon="pi-info-circle" data={leftover} />
                )}
                <RawResponseButton data={d} />
            </div>
        </div>
    );
};

export default CompanyDetailsOutputComponent;
